import React, { useState } from 'react';
import {
    Modal,
    Box,
    Typography,
    Grid,
    Button,
    IconButton,
    TextField,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { getCallsSummaryReport } from '../../../actions/prospections';
import { formatDateMX } from '../../../helpers/hours';
import esLocale from 'date-fns/locale/es';
import {
    handleError,
    handleSuccess,
    handleWarning,
} from '../../../helpers/utils';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
    borderRadius: 2,
};

export const SummaryModalProspects = ({ open, onClose }) => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const handleClear = () => {
        setStartDate(null);
        setEndDate(null);
    };

    const handleExport = () => {
        if (!startDate || !endDate) {
            handleWarning('Debe seleccionar un rango de fechas para exportar.');
            return;
        }

        const date1 = startDate.toISOString().split('T')[0];
        const date2 = endDate.toISOString().split('T')[0];

        getCallsSummaryReport(date1, date2)
            .then(response => {
                // Generate the file name with the current formatted date
                const today = new Date();
                const formattedDate = formatDateMX(
                    today.toISOString().split('T')[0]
                );
                const fileName = `RESUMEN_PROSPECCIONES-${formattedDate}.xlsx`;

                // Generating file and handling download
                const url = window.URL.createObjectURL(
                    new Blob([response.data])
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);

                handleSuccess('Reporte descargado con éxito.');

                onClose();
            })
            .catch(error => {
                handleError(error, 'Error al obtener el reporte de llamadas.');
            });
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="summary-modal-title"
        >
            <Box sx={modalStyle}>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                >
                    <Typography
                        id="summary-modal-title"
                        variant="h6"
                        sx={{ fontWeight: 'bold' }}
                    >
                        Resumen de Prospecciones
                    </Typography>
                    <IconButton
                        onClick={onClose}
                        aria-label="Cerrar"
                        size="small"
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>

                <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    locale={esLocale}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <DatePicker
                                label="Fecha de inicio"
                                value={startDate}
                                onChange={newValue => {
                                    setStartDate(newValue);
                                }}
                                renderInput={params => (
                                    <TextField {...params} fullWidth />
                                )}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <DatePicker
                                label="Fecha de fin"
                                value={endDate}
                                onChange={newValue => {
                                    setEndDate(newValue);
                                }}
                                renderInput={params => (
                                    <TextField {...params} fullWidth />
                                )}
                            />
                        </Grid>
                    </Grid>
                </LocalizationProvider>

                <Box display="flex" justifyContent="flex-end" mt={3}>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleClear}
                        sx={{ mr: 2 }}
                    >
                        Limpiar
                    </Button>
                    <Button
                        variant="contained"
                        color="success"
                        onClick={handleExport}
                    >
                        Exportar
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};
